import script from "./GoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./GoPage.vue?vue&type=script&setup=true&lang=js"

import "./GoPage.vue?vue&type=style&index=0&id=03aca93f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03aca93f"]])

export default __exports__